import { UserActivity } from 'src/components/widgets/display-blocks/user-activity';
import { CasesComments } from './CasesComments';
import { editCaseStyles } from './stylesheet';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import { List as MuiList, ListItem } from '@material-ui/core';
import parseHTML from 'html-react-parser';

type TimelineTypes = {
  id: string;
  description: string;
  createdBy: {
    id: string;
    name: string;
  };
  createdAt: string;
  changeFrom?: string | null;
  changeTo?: string | null;
  change: string | null;
  isExternal?: boolean;
  attachmentPath?: string;
};

type TimelineSectionTypes = {
  user: any;
  data: TimelineTypes[];
  caseData: any;
  toggleIsLoad: () => void;
  languageType?: string;
  showTranslation?: any;
  handleDocumentClick?: any;
  handleImageClick?: any;
};
const useStyles = editCaseStyles;

export const TimelineSection = ({
  user,
  data,
  caseData,
  toggleIsLoad,
  languageType,
  showTranslation,
  handleDocumentClick,
  handleImageClick,
}: TimelineSectionTypes) => {
  const classes = useStyles();
  return (
    <>
      {(user?.permissions?.includes('case-comment-get-all') ||
        user?.permissions?.includes('case-comment-create')) && (
        <CasesComments
          caseData={caseData}
          toggleIsLoad={toggleIsLoad}
          user={user}
          languageType={languageType}
          showTranslation={showTranslation}
          handleDocumentClick={handleDocumentClick}
          handleImageClick={handleImageClick}
        />
      )}
      {user?.permissions?.includes('case-timeline-activity-get-all') && (
        <MuiList className={classes.timelineRoot}>
          {data?.length ? (
            <>
              <span
                style={{
                  fontSize: '16px',
                  fontWeight: 600,
                }}>
                Logs
              </span>
              {caseData?.logs?.map((item: TimelineTypes) => (
                <UserActivity
                  key={item?.id}
                  // image={{ src: '/static/icons/avatar.png', alt: item?.createdBy?.name }}
                  meta={{
                    description: item?.description,
                    createdBy: item?.createdBy.name,
                    createdAt: item?.createdAt,
                    change:
                      item?.change === null ? '' : parseHTML(item?.change),
                  }}
                  filesPath={item?.attachmentPath}
                  actions={
                    [
                      // <Button
                      //   size="small"
                      //   title="Translate"
                      //   type="button"
                      //   onClick={(e) => {
                      //     e.preventDefault();
                      //     e.stopPropagation();
                      //     if (item?.change !== null) {
                      //       showTranslation(
                      //         item?.change,
                      //         languageType,
                      //         'caseLogData',
                      //         item?.id
                      //       );
                      //     }
                      //   }}
                      //   sx={{ padding: '0' }}>
                      //   Translate
                      // </Button>,
                    ]
                  }
                  details={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                      }}>
                      {item?.changeFrom && (
                        <span style={{ fontSize: '12px' }}>
                          {item?.changeFrom === null
                            ? 'none'
                            : parseHTML(item?.changeFrom)}
                        </span>
                      )}
                      {item?.changeTo && (
                        <>
                          <span
                            style={{
                              flex: '0 0 40px',
                              textAlign: 'center',
                              margin: '-2px 0 0',
                            }}>
                            <ArrowRightAltIcon />
                          </span>
                          <span style={{ fontSize: '12px' }}>
                            {item?.changeTo === null
                              ? 'none'
                              : parseHTML(item?.changeTo)}
                          </span>
                        </>
                      )}
                    </div>
                  }
                />
              ))}
            </>
          ) : (
            <>
              <ListItem style={{ display: 'flex', justifyContent: 'center' }}>
                <strong>No Data Found</strong>
              </ListItem>
            </>
          )}
        </MuiList>
      )}
    </>
  );
};
